import {
  Component,
  OnInit,
  ChangeDetectorRef,
  Input,
  OnDestroy,
} from '@angular/core';
import { ModalController } from '@ionic/angular';

import { Sale } from '../../../models/sale/sale.model';
import { UserService } from '../../../services/user.service';
import { SquarePOSService } from '../../../services/square-pos.service';
import {
  SaleService,
} from '../../../services/sale.service';
import { Router } from '@angular/router';
import { NavigationStateService } from 'src/app/services/navigation-state.service';

@Component({
  selector: 'app-sale-payment',
  templateUrl: './sale-payment.page.html',
  styleUrls: ['./sale-payment.page.scss'],
})
export class SalePaymentPage implements OnInit, OnDestroy {
  @Input() sale: Sale;

  // public paymentButtons: Array<Object>;

  @Input() checkOutPromise: Function;

  @Input() isFromBookings: boolean;
  @Input() isFromRegisterClosure;

  cashTip: boolean = false;

  public navigationStateSubscription;

  constructor(
    //private navCtrl: NavController,
    //private navParams: NavParams,
    private userService: UserService,
    private saleService: SaleService,
    private modalCtrl: ModalController,
    private squarePOSService: SquarePOSService,
    // private paypalPOSService: PaypalPOSService,
    private changeDetectorRef: ChangeDetectorRef,
    private router: Router,
    private navigationStateService: NavigationStateService
  ) {
    this.navigationStateSubscription = this.navigationStateService.getState().subscribe((state) => {
      this.sale = state.sale;
        this.isFromBookings = state.isFromBookings;
        this.isFromRegisterClosure = state.isFromRegisterClosure
    });
  }

  public ngOnInit() {
  }

  public ngOnDestroy() {
    this.navigationStateSubscription.unsubscribe();
  }

  public ionViewCanEnter() {
    if (!this.userService.isLoggedIn()) {
      setTimeout(() => {
        // this.navCtrl.setRoot("LoginPage");
        this.router.navigateByUrl('/login');
      }, 100);
      return false;
    }

    if (!this.sale) {
      setTimeout(() => {
        //this.navCtrl.setRoot("SaleManagerPage");
        this.router.navigateByUrl('/sale-manager');
      }, 100);
      return false;
    }

    return true;
  }

  public onSaleUpdated(sale: Sale) {
    this.sale = sale;
    if(this.sale.balance < 0 && this.sale.payments.count() == 1 && this.sale.payments.first().type == 1){
      this.cashTip = true
    }
    this.changeDetectorRef.markForCheck();
  }
}
